(() => {
  const menus=[...document.querySelectorAll('.v3menu')];
  const fine=matchMedia('(hover:hover) and (pointer:fine)');
  function closeOthers(current){menus.forEach(m=>{if(m!==current)m.open=false;});}
  menus.forEach(menu=>{
    let timer;
    const open=()=>{clearTimeout(timer);closeOthers(menu);menu.open=true;};
    menu.querySelector('summary').addEventListener('click',e=>{if(fine.matches&&e.detail>0){e.preventDefault();open();}});
    menu.addEventListener('pointerenter',()=>{if(fine.matches)open();});
    menu.addEventListener('pointerleave',()=>{if(fine.matches)timer=setTimeout(()=>{if(!menu.contains(document.activeElement))menu.open=false;},160);});
    menu.addEventListener('toggle',()=>{if(menu.open)closeOthers(menu);});
    menu.addEventListener('focusout',()=>setTimeout(()=>{if(!menu.contains(document.activeElement)&&!menu.matches(':hover'))menu.open=false;},0));
    menu.addEventListener('keydown',e=>{
      if(e.key==='Escape'){menu.open=false;menu.querySelector('summary').focus();}
      if(e.key==='ArrowDown'&&e.target===menu.querySelector('summary')){e.preventDefault();open();menu.querySelector('a').focus();}
    });
  });
  document.addEventListener('click',e=>{if(!e.target.closest('.v3menu'))closeOthers();});
  addEventListener('resize',()=>{if(innerWidth<990)closeOthers();});
  const track=document.querySelector('.v3review-widget .jdgm-carousel__item-container');
  if(!track)return;
  const reduced=matchMedia('(prefers-reduced-motion:reduce)');
  const buttons=[...document.querySelectorAll('[data-review-step]')];
  const sync=()=>buttons.forEach(b=>{b.disabled=Number(b.dataset.reviewStep)<0?track.scrollLeft<4:track.scrollLeft+track.clientWidth>=track.scrollWidth-4;});
  buttons.forEach(b=>b.addEventListener('click',()=>{
    const item=track.querySelector('.jdgm-carousel-item');
    track.scrollBy({left:Number(b.dataset.reviewStep)*(item.getBoundingClientRect().width+16),behavior:reduced.matches?'instant':'smooth'});
  }));
  track.setAttribute('tabindex','0');track.setAttribute('role','region');track.setAttribute('aria-label','Opiniones reales de Judge.me');
  track.addEventListener('scroll',sync,{passive:true});addEventListener('resize',sync);sync();
  document.querySelectorAll('.v3review-more').forEach(b=>b.addEventListener('click',()=>{
    const open=b.getAttribute('aria-expanded')!=='true';
    b.setAttribute('aria-expanded',String(open));b.textContent=open?'Ver menos':'Leer completa';b.closest('.jdgm-carousel-item').classList.toggle('is-expanded',open);
  }));
})();
